import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

// CSS
import './index.scss';

/**
 * @param section
 * @param row
 * @param seats
 */
const SectionRowSeatGA = ({className = ''}) => {
  return (
    <div className={`SectionRowSeatGA ${className}`}>
      <FormattedMessage id="SectionRowSeatGA.section" defaultMessage="General Admission" />
    </div>
  );
};

SectionRowSeatGA.propTypes = {
  /**
   * The Class Name used to override the Styling for the component.
   *
   */
  className: PropTypes.string,
};

export default SectionRowSeatGA;
